import { render, staticRenderFns } from "./common-file-upload.vue?vue&type=template&id=1c7067c8&scoped=true"
import script from "./common-file-upload.vue?vue&type=script&lang=js"
export * from "./common-file-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7067c8",
  null
  
)

export default component.exports